import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useLang, pick } from "@/contexts/LanguageContext";
import { routeDetailPath } from "@/i18n/routeMap";

function mainImage(r) {
  const media = (r.routeMedia || []).slice().sort((a, b) => (a.order || 0) - (b.order || 0));
  const m = media.find((x) => x.isMain) || media[0];
  if (m) return m.posterUrl || m.url;
  if (Array.isArray(r.images) && r.images.length) return typeof r.images[0] === "string" ? r.images[0] : r.images[0].url;
  return "";
}

export default function RouteCard({ route, index = 0 }) {
  const { lang, t } = useLang();
  const slug = pick(route.slug, lang);
  const title = pick(route.title, lang);
  const desc = pick(route.shortDescription, lang);
  const image = mainImage(route);

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: (index % 6) * 0.06 }}
      data-testid={`route-card-${slug}`}>
      <Link to={routeDetailPath(slug, lang)} className="group block">
        <div className="relative aspect-[16/10] overflow-hidden bg-[#2A2A2A]">
          <img src={image} alt={title} loading="lazy"
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0C0C0C] via-[#0C0C0C]/30 to-transparent" />
          <div className="absolute top-4 left-4 text-overline text-[#C9A55A]">{String(index + 1).padStart(2, "0")}</div>
        </div>
        <div className="pt-6">
          <h3 className="font-display text-[#F5F1EB] text-2xl md:text-3xl leading-tight group-hover:text-[#C9A55A] transition-colors">{title}</h3>
          {desc && <p className="mt-3 text-sm text-[#8A8A8A] font-light leading-relaxed line-clamp-3">{desc}</p>}
          <div className="mt-5 flex items-center gap-2 text-[#C9A55A] text-xs tracking-[0.18em] uppercase font-semibold">
            {t.routes.explore} <ArrowUpRight size={14} />
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
